import { render, staticRenderFns } from "./CreateTemplateFromPosition.vue?vue&type=template&id=0c696a5b&"
import script from "./CreateTemplateFromPosition.vue?vue&type=script&lang=js&"
export * from "./CreateTemplateFromPosition.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports